<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Danh sách sản phẩm
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage !== undefined && errorMessage.length > 0" v-for="(error, key) in errorMessage" :key="error">
                        <span>{{error}}</span>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError(key)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                            <div class="col-sm-11 d-flex flex-column">
                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <SelectNormal
                                           :label="dataSearch.store_id.label"
                                           :id="dataSearch.store_id.id"
                                           :placeholder="dataSearch.store_id.placeholder"
                                           :value-default="dataSearch.store_id.value"
                                           @inputValue="onChange($event, dataSearch.store_id.id)"
                                           :required="dataSearch.store_id.required"
                                           :options="dataSearch.store_id.options"
                                        ></SelectNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.token_name.label"
                                                :id="dataSearch.token_name.id"
                                                :placeholder="dataSearch.token_name.placeholder"
                                                :value-default="dataSearch.token_name.value"
                                                @inputValue="onChange($event, dataSearch.token_name.id)"
                                                :required="dataSearch.token_name.required"
                                        ></InputTextNormal>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-11 d-flex flex-column">
                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.token.label"
                                                :id="dataSearch.token.id"
                                                :placeholder="dataSearch.token.placeholder"
                                                :value-default="dataSearch.token.value"
                                                @inputValue="onChange($event, dataSearch.token.id)"
                                                :required="dataSearch.token.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <SelectNormal
                                                :label="dataSearch.expired_at.label"
                                                :id="dataSearch.expired_at.id"
                                                :placeholder="dataSearch.expired_at.placeholder"
                                                :value-default="dataSearch.expired_at.value"
                                                @inputValue="onChange($event, dataSearch.expired_at.id)"
                                                :error-text="dataSearch.expired_at.error"
                                                :is-error="dataSearch.expired_at.isError"
                                                :required="dataSearch.expired_at.required"
                                                :options="dataSearch.expired_at.options"
                                        ></SelectNormal>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-1 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSearch" @click="searchGHTK"></ButtonSearchComponent>
                            </div>
                        </div>

                    </div>
                    <div class="btn-invite-partner">
                        <ButtonAddComponent :width="'200px'" :label="labelButtonCreate" @click="redirectToCreate" ></ButtonAddComponent>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-between mt-4">
                        <div class="action d-flex align-items-center gap-3">
                            <div class="total">
                                {{ CommonText.TOTAL_RECORD(listGHTK.length, paginate.itemCount) }}
                            </div>
                            <div class="dropdown-action">
                                <SelectCustom
                                        :label="selectAction.label"
                                        :id="selectAction.id"
                                        :placeholder="selectAction.placeholder"
                                        :value-default="selectAction.value"
                                        :required="selectAction.required"
                                        :options="selectAction.options"
                                        @action="actionSelect($event)"
                                ></SelectCustom>
                            </div>
                        </div>
                        <div class="action-left d-flex align-items-center gap-3">
                            <div class="dropdown-action">
                                <SelectCustom
                                        :label="selectLimitPage.label"
                                        :id="selectLimitPage.id"
                                        :placeholder="selectLimitPage.placeholder"
                                        :value-default="selectLimitPage.value"
                                        :required="selectLimitPage.required"
                                        :options="selectLimitPage.options"
                                        @action="actionLimitPage($event)"
                                ></SelectCustom>
                            </div>
                        </div>
                    </div>
                    <div class="list-partners-component">
                        <table class="table">
                            <thead>
                            <tr>
                                <th scope="col" style="width: 2%;"><InputCheckboxOne id="select_all" :value-default="checkAll" @inputValue="onChangeSelectAll($event)" :checked="checkAll"></InputCheckboxOne></th>
                                <th scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">{{header.label}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="listGHTK.length > 0" v-for="sync in listGHTK" :key="sync.id">
                                <td><InputCheckboxOne :id="sync.id" :value-default="checkItems[sync.id]" @inputValue="onChangeSelectItem($event, sync.id)" :checked="checkItems[sync.id]"></InputCheckboxOne></td>
                                <td>{{sync.store?.name}}</td>
                                <td class="product-name"><p @click="showSyncGHTKDetail(sync.id)">{{sync.token_name}}</p></td>
                                <td>{{CommonService.compareStatusSyncGHTKLabel(sync.status)}}</td>
                                <td>{{sync.token}}</td>
                                <td>{{sync.expired_at ? CommonService.formatDate(sync.expired_at) : 'Không bao giờ'}}</td>
                            </tr>
                            <tr v-else>
                                <td colspan="5" class="text-center">Không có dữ lệu được tìm thấy!</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <PaginateComponent v-if="listGHTK.length > 0 && paginate.pageCount > 1" :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"></PaginateComponent>
                </div>
            </div>
        </div>
    </div>
</div>
<ModalCalendarComponent @dateSelected="actionDateSelected($event)"></ModalCalendarComponent>
<LoadingComponent v-if="isLoading"></LoadingComponent>

